export default __webpack_public_path__ + "static/media/sign-in-google.62618f14.gif";